export default {
  // 模块名称
  workshopRecord: {
    // 按钮类
    button: {
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      close: 'Close',
      detail: 'Detail'
    },
    // 文字标签类
    label: {
      name: 'Name',
      workNumber: 'Work Number',
      phone: 'Phone',
      applicationWorkshop: 'Application Workshop',
      entryTime: 'Entry Time',
      leaveTime: 'Leave Time',
      desc: 'Application Description',
      status: 'Application Status',
      operations: 'Operations',
      image: 'Image'
    },
    // 提示类
    placeholder: {
      select: 'Select',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: 'Record details'
    }
  }
}